// // components/homeseo.tsx
// import Link from "next/link";

// export default function HomeAuthoritySection() {
//   return (
//     <section className="max-w-7xl mx-auto px-6 md:px-10 py-16">
//       <div className="px-4 md:px-0">
//         <div className="relative overflow-hidden rounded-[28px] border border-purple-100 dark:border-purple-900 bg-white dark:bg-gray-900">
//           <div className="absolute inset-0 bg-gradient-to-br from-purple-100 via-white to-purple-50 dark:from-purple-950 dark:via-gray-900 dark:to-gray-900" />
//           <div className="absolute -top-28 -right-28 h-80 w-80 rounded-full bg-purple-300/25 blur-3xl" />
//           <div className="absolute -bottom-28 -left-28 h-80 w-80 rounded-full bg-purple-300/20 blur-3xl" />

//           <div className="relative p-8 md:p-12">
//             <h2 className="mt-6 text-center text-xl md:text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
//               LilyLanka – SLTDA Registered Sri Lanka Travel &amp; Hotel Booking
//               Platform
//             </h2>

//             <div className="mt-4 flex justify-center">
//               <div className="h-1 w-28 rounded-full bg-gradient-to-r from-purple-500 to-purple-500" />
//             </div>

//             <p className="mt-6 mx-auto max-w-4xl text-center text-sm md:text-md leading-relaxed text-slate-700 dark:text-slate-300">
//               LilyLanka is a Sri Lanka Tourism Development Authority (SLTDA)
//               registered travel platform offering secure and trusted Sri Lanka
//               travel services for international and local travelers. We provide{" "}
//               <span className="font-semibold text-slate-900 dark:text-white">
//                 verified hotel bookings in Sri Lanka
//               </span>
//               , curated attractions, licensed tour guide services, travel eSIM,
//               travel insurance assistance, and essential emergency support
//               information - all in one place.
//             </p>

//             <div className="mt-10 grid gap-6 md:grid-cols-2">
//               {/* Left card */}
//               <div className="rounded-2xl border border-purple-100 dark:border-purple-900 bg-white/80 dark:bg-gray-800/80 p-6 shadow-sm">
//                 <div className="flex items-start gap-3">
//                   <div>
//                     <h3 className="text-lg font-bold text-slate-900 dark:text-white">
//                       Book Hotels Across Sri Lanka
//                     </h3>
//                     <p className="mt-3 text-sm md:text-base leading-relaxed text-slate-700 dark:text-slate-300">
//                       Easily book Sri Lanka hotels in Colombo, Kandy, Ella,
//                       Galle, and top tourist destinations across the island.
//                       Explore cultural sites, beaches, wildlife parks, and
//                       adventure experiences through our dedicated Explore Sri
//                       Lanka section.
//                     </p>
//                     <div className="mt-4 flex flex-wrap gap-2">
//                       {["Colombo", "Kandy", "Ella", "Galle"].map((city) => (
//                         <span
//                           key={city}
//                           className="rounded-full bg-purple-50 dark:bg-purple-950 text-purple-700 dark:text-purple-300 border border-purple-100 dark:border-purple-800 px-3 py-1 text-xs font-semibold"
//                         >
//                           {city}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Right card */}
//               <div className="rounded-2xl border border-emerald-100 dark:border-emerald-900 bg-white/80 dark:bg-gray-800/80 p-6 shadow-sm">
//                 <div className="flex items-start gap-3">
//                   <div>
//                     <h3 className="text-lg font-bold text-slate-900 dark:text-white">
//                       Sri Lanka Tourism Development Authority
//                       <br />
//                       <small>Compliant Travel Planning</small>
//                     </h3>
//                     <p className="mt-3 text-sm md:text-base leading-relaxed text-slate-700 dark:text-slate-300">
//                       Our platform ensures safe, reliable, and transparent
//                       travel planning with SLTDA-compliant services, making
//                       LilyLanka your complete Sri Lanka travel and tourism
//                       solution.
//                     </p>
//                     <div className="mt-4 flex flex-wrap gap-2">
//                       {[
//                         "Verified stays",
//                         "Trusted services",
//                         "Secure bookings",
//                       ].map((chip) => (
//                         <span
//                           key={chip}
//                           className="rounded-full bg-purple-50 dark:bg-purple-950 text-purple-700 dark:text-purple-300 border border-purple-100 dark:border-purple-800 px-3 py-1 text-xs font-semibold"
//                         >
//                           {chip}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* CTA */}
//             <div className="mt-10 rounded-2xl border border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-gray-800/70 p-6 text-center shadow-sm">
//               <p className="text-base md:text-xl font-bold text-slate-900 dark:text-white">
//                 Plan, book, and explore Sri Lanka with confidence.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
// components/homeseo.tsx
"use client";

// components/homeseo.tsx
import Link from "next/link";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";

const DIGITAL_OCEAN_SPACES_CDN =
  "https://lilylanka-public-prod.sgp1.cdn.digitaloceanspaces.com";

export default function HomeAuthoritySection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -80px 0px" },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative max-w-7xl mx-auto px-6 md:px-10 py-16 overflow-hidden"
    >
      {/* Offset color panel behind the text column */}
      <div className="absolute inset-y-4 left-0 right-0 md:left-[34%] rounded-[28px] bg-gradient-to-br from-purple-100 via-purple-50 to-white dark:from-purple-950 dark:via-gray-900 dark:to-gray-900" />

      <div className="relative grid md:grid-cols-12 gap-10 md:gap-12 items-start">
        {/* Left: bleeding image */}
        <div
          className={`md:col-span-5 transition-all duration-700 ease-out ${
            isVisible
              ? "opacity-100 translate-y-0 translate-x-0"
              : "opacity-0 translate-y-8 md:translate-y-0 md:-translate-x-10"
          }`}
        >
          <div className="relative h-[320px] md:h-[560px] md:-mt-6 rounded-tl-[80px] rounded-tr-[16px] rounded-bl-[16px] rounded-br-[80px] overflow-hidden shadow-xl">
            <Image
              src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/destinations/galle.jpg`}
              alt="LilyLanka - Sri Lanka travel and hotel booking platform"
              fill
              className="object-cover"
              sizes="(max-width: 768px) 100vw, 40vw"
            />
          </div>
        </div>

        {/* Right: content */}
        <div
          className={`md:col-span-7 md:pl-2 md:pt-10 transition-all duration-700 ease-out delay-150 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-xs font-bold uppercase tracking-[0.18em] text-purple-600 dark:text-purple-300">
            SLTDA Registered Platform
          </span>

          <h2 className="mt-4 font-serif text-3xl md:text-5xl leading-tight font-medium tracking-tight text-slate-900 dark:text-white">
            LilyLanka – SLTDA Registered Sri Lanka Travel &amp; Hotel Booking
            Platform
          </h2>

          <div className="mt-6 h-1 w-28 rounded-full bg-gradient-to-r from-purple-500 to-purple-500" />

          <p className="mt-6 max-w-xl text-sm md:text-base leading-relaxed text-slate-700 dark:text-slate-300">
            LilyLanka is a Sri Lanka Tourism Development Authority (SLTDA)
            registered travel platform offering secure and trusted Sri Lanka
            travel services for international and local travelers. We provide{" "}
            <span className="font-semibold text-slate-900 dark:text-white">
              verified hotel bookings in Sri Lanka
            </span>
            , curated attractions, licensed tour guide services, travel eSIM,
            travel insurance assistance, and essential emergency support
            information - all in one place.
          </p>

          <div className="mt-10 space-y-8">
            {/* Left card content, restyled as editorial block */}
            <div className="border-l-4 border-purple-500 pl-5">
              <h3 className="text-lg font-bold text-slate-900 dark:text-white">
                Book Hotels Across Sri Lanka
              </h3>
              <p className="mt-2 text-sm md:text-base leading-relaxed text-slate-700 dark:text-slate-300">
                Easily book Sri Lanka hotels in Colombo, Kandy, Ella, Galle, and
                top tourist destinations across the island. Explore cultural
                sites, beaches, wildlife parks, and adventure experiences
                through our dedicated Explore Sri Lanka section.
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                {["Colombo", "Kandy", "Ella", "Galle"].map((city) => (
                  <span
                    key={city}
                    className="rounded-full bg-purple-50 dark:bg-purple-950 text-purple-700 dark:text-purple-300 border border-purple-100 dark:border-purple-800 px-3 py-1 text-xs font-semibold"
                  >
                    {city}
                  </span>
                ))}
              </div>
            </div>

            {/* Right card content, restyled as editorial block */}
            <div className="border-l-4 border-purple-300 pl-5">
              <h3 className="text-lg font-bold text-slate-900 dark:text-white">
                Sri Lanka Tourism Development Authority
                <br />
                <small>Compliant Travel Planning</small>
              </h3>
              <p className="mt-2 text-sm md:text-base leading-relaxed text-slate-700 dark:text-slate-300">
                Our platform ensures safe, reliable, and transparent travel
                planning with SLTDA-compliant services, making LilyLanka your
                complete Sri Lanka travel and tourism solution.
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                {["Verified stays", "Trusted services", "Secure bookings"].map(
                  (chip) => (
                    <span
                      key={chip}
                      className="rounded-full bg-purple-50 dark:bg-purple-950 text-purple-700 dark:text-purple-300 border border-purple-100 dark:border-purple-800 px-3 py-1 text-xs font-semibold"
                    >
                      {chip}
                    </span>
                  ),
                )}
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-10 border-l-4 border-purple-500 pl-5">
            <p className="text-base md:text-xl font-bold text-slate-900 dark:text-white">
              Plan, book, and explore Sri Lanka with confidence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
